import { cn } from '../../../lib/styles';
import type { FormGap, FormProps } from './types';

const GAP_MAP: Record<FormGap, string> = {
  sm: 'gap-2',
  md: 'gap-4',
};

export function FormBase({ children, onSubmit, onReset, gap = 'md' }: FormProps) {
  return (
    <form
      className={cn('flex flex-col', GAP_MAP[gap])}
      onSubmit={async (e) => {
        e.preventDefault();
        e.stopPropagation();

        await onSubmit?.();
      }}
      onReset={async (e) => {
        e.preventDefault();
        e.stopPropagation();

        await onReset?.();
      }}
    >
      {children}
    </form>
  );
}
